import '../scss/main.scss';

import {
    defineCustomElements,
    applyPolyfills,
} from '@vision/ui-landings/dist/loader';

defineCustomElements();

window.addEventListener('load', (event) => {
    grecaptcha.execute();
});

document.addEventListener('DOMContentLoaded', () => {
    let formFiles = [];
    let fileInputWrapper = document.querySelector('.form__file-wrapper');
    let fileInput = fileInputWrapper.querySelector('input[type="file"]');
    let fileListWrapper = fileInputWrapper.querySelector('.form__file-list');
    let formContent = document.querySelector('.form__content');
    let formRadioButtons = formContent.querySelectorAll(
        '.form__radio lui-radio');
    let formInputs = formContent.querySelectorAll(
        'input[type="text"], textarea');
    let conditionsCheckbox = document.querySelector(
        '.form__checkbox lui-checkbox');
    let submitButton = document.querySelector('.form__submit lui-button');

    const allowedFileTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp',
        'video/mp4',
        'application/x-mpegURL',
        'video/MP2T',
        'video/3gpp',
        'video/quicktime',
        'video/x-msvideo',
        'video/x-ms-wmv',
        'application/pdf',
        'image/gif',
    ];

    conditionsCheckbox.addEventListener('luiCheckboxChange', e => {
        submitButton.disabled = !conditionsCheckbox.checked;
    });

    submitButton.addEventListener('click', e => {
        let g_recaptcha_response = document.querySelector('.g-recaptcha-response');
        if(!g_recaptcha_response.value){
            grecaptcha.execute();
        }

        let data = parseData();
        if (data) {
            sendData(data);
        }
    });

    fileInputWrapper.addEventListener('dragover', e => {
        e.preventDefault();
    });

    fileInputWrapper.addEventListener('drop', e => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
            addFilesToFileList(e.dataTransfer.files);
        }
    });

    fileInput.addEventListener('change', e => {
        e.preventDefault();
        if (fileInput.files) {
            addFilesToFileList(fileInput.files);
        }
        fileInput.value = null;
    });

    fileListWrapper.addEventListener('click', e => {
        if (e.target.tagName == 'I') {
            formFiles = formFiles.filter(file => {
                return file.name !==
                    e.target.closest('.form__file-item').textContent.trim();
            });
            updateFileList();
        }
    });

    formInputs.forEach(input => {
        input.addEventListener('input', e => {
            let msg = input.closest('.form__content-input').
                querySelector('.error-message');
            msg.classList.remove('error-message-active');
        });
    });

    function dropForm() {
        formInputs.forEach(input => {
            input.value = '';
        });
        formFiles = [];
        conditionsCheckbox.checked = false;
        formRadioButtons.forEach(radio => radio.checked = false);
        formRadioButtons[0].checked = true;
        submitButton.disabled = true;
        updateFileList();
    }

    function addFilesToFileList(files) {
        let notAllowedFiles = {};
        [...files].forEach(file => {
            if (!allowedFileTypes.includes(file.type) ||
                file.name.includes('.php')) {
                notAllowedFiles[file.name] = ' are not valid, please load only images/videos/pdf.';
            } else if (file.size / 1024 / 1024 > 64) {
                notAllowedFiles[file.name] = ' file size exceeds the limit, please upload files smaller than 64 megabytes';
            } else {
                formFiles.push(file);
            }
        });
        if (Object.keys(notAllowedFiles).length) {
            if (Object.keys(notAllowedFiles).length > 1) {
                let message = '';
                Object.entries(notAllowedFiles).
                    forEach(([key, value], index) => {
                        message += key + value +
                            `${index < Object.entries(notAllowedFiles).length -
                            1 ? '<br/><br/>' : ''}`;
                    });
                showModal(message);
            } else {
                showModal(Object.entries(notAllowedFiles)[0][0] +
                    Object.entries(notAllowedFiles)[0][1]);
            }
        }
        updateFileList();
    }

    function updateFileList() {
        fileListWrapper.innerHTML = '';
        if (formFiles.length) {
            fileListWrapper.classList.add('form__file-list-active');
        } else {
            fileListWrapper.classList.remove('form__file-list-active');
        }

        formFiles.forEach(file => {
            let fileElem = document.createElement('div');
            fileElem.classList.add('form__file-item');
            fileElem.innerHTML = `${file.name.replace(/[^a-z0-9.]/gi, '_').toLowerCase()}<i></i>`;
            fileListWrapper.appendChild(fileElem);
        });
    }

    function parseData() {
        let formData = new FormData();
        let validation = true;
        formData.append('platform', [...formRadioButtons].filter(radio => {
            return radio.checked;
        })[0].label);

        formInputs.forEach(input => {
            let msg = input.closest('.form__content-input').
                querySelector('.error-message');
            if ((!input.value && input.required)
                || (input.name == 'url' && !checkURL(input.value))
                || (input.name == 'email' && !checkEmail(input.value))
            ) {
                msg.classList.add('error-message-active');
                if (validation) {
                    window.scrollTo({
                        top: input.closest('.form__content-item').offsetTop,
                        behavior: 'smooth',
                    });
                }
                validation = false;
            } else {
                msg.classList.remove('error-message-active');
                formData.append([input.name], input.value);
            }
        });
        if (formFiles.length) {
            formFiles.forEach((file, index) => {
                formData.append(`file${index}`, file, file.name);
            });
        }
        return validation ? formData : null;
    }

    function sendData(data) {
        submitButton.disabled = true;
        let g_recaptcha_response = document.querySelector('.g-recaptcha-response');
        data.append('recaptcha', g_recaptcha_response.value);
        fetch(`${window.location.origin}/mail.php`, {
            method: 'POST',
            body: data,
        }).then(async (res) => {
            let parsedRes = await res.json();
            showModal(parsedRes.message);
            if (res.status == 200 && parsedRes.success == true) {
                dropForm();
            } else {
                submitButton.disabled = false;
            }
            grecaptcha.reset();
            grecaptcha.execute();
        }).catch(err => {
            showModal('Error on sending message.');
            submitButton.disabled = false;
            grecaptcha.reset();
            grecaptcha.execute();
        });
    }

    function showModal(message) {
        let modal = document.querySelector('.modal');
        let modalContent = modal.querySelector('.modal__content');

        modalContent.innerHTML = message;
        modal.classList.add('modal-active');
        setTimeout(() => {
            modal.classList.remove('modal-active');
        }, 7500);
    }

    function checkEmail(email) {
        return String(email).toLowerCase().match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
    }

    function checkURL(url) {
        let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(url);
    }
});

function onSubmit(token) {
    document.getElementById('demo-form').submit();
}